import React, { Component } from 'react';
// import donorDataCategories from '../../../test/donorDataCategories';
import iScroll from 'iscroll';
import ScrollSpacer from './ScrollSpacer';
import ReactIScroll from 'react-iscroll';
import DonorFullPage from '../Tampa/DonorFullPage';
import { isNull } from 'util';
import { connect } from 'react-redux';
import {dp} from '../../../utils/shared.js';
import _ from 'lodash';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import { getDonorsFromFolder } from '../../../utils/donorHelpers';
const QuillDeltaToHtmlConverter = require('quill-delta-to-html');

class MiamiRecognitionList extends Component {

  constructor(props) {
    //defaults
    super(props);

    this._subscribeModule = null;
    this._rowWrapperRef = null;
    // this.getSubscribeModule();

    this._columns = 2;
    this._rows = 6;
    this._fontColor = "#ffffff";
    this._backdropColor = "#000000";
    this._footerText = "";
    this._parentCategoryName = ""; //used to stash name so state can switch to empty string
    this._ni_options = {};
    this._metaCycleTimeout = null;
    this._listCycleTime = 8000;
    this._marginRight = this.props.screen.sv.width * 0.0375;
    this._fontClass = 'gfont_roboto';
    this._donorCategories = null;
    this._recognitionOptionsRef = null;

    this._donorGroups = this.props.module.children;
    const rootFolderId = _.get(this.props.content, 'settings.selected_root_folder', null);
    const rootFolder = this.props.content.story_categories.find(folder => folder.id === Number(rootFolderId));
    this._colorPallette = _.get(rootFolder, 'contents.custom_fields.color_pallette.val.value', 'golisano');

    this.state = {
      donorGroup: 0
    };
  }

  componentDidMount() {
    this.checkSwipeAnimation();
    this.getSubscribeModule();
  }

  checkSwipeAnimation = () => {
    const wrapperHeight = this._wrapperDiv.getBoundingClientRect().height;
    const contentHeight = this._innerDivRef.getBoundingClientRect().height;
  
    this.props.handleSwipeAnimation(wrapperHeight, contentHeight);
  }

  handleScrollStart = () => {
    this.props.cancelSwipeAnimation();
  }

  beTheChange = (obj) => {
    let learnMoreButton = "/img/miami/general/learnmore_grad_button.png";
    if (this._colorPallette === "adaptive") {
      learnMoreButton = "/img/miami/general/learnmore_grad_button_green.png";
    }
    return (
      <div key="be the change" style={{ marginTop: '7vw', marginBottom: '5vw', display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', justifyContent: 'flex-start', alignItems: 'stretch', alignContent: 'stretch', width: "44.2708vh", marginRight: "auto", marginLeft: "auto" }} onClick={this.redirect}>
        <div style={{ fontSize: '3.5vw', lineHeight: "107%", textAlign: "left", fontFamily: "opensans-semibold", color: '#ffffff', width: '150vw' }}>
          Be the Change
            <br />
          <span style={{ fontSize: '2.2vw', textAlign: "left", fontFamily: "opensans-regular", color: '#ffffff' }}>
            Help make a difference by becoming a donor.
                </span>
        </div>

        <div style={{ textAlign: 'right', width: '100%' }} onClick={this.redirect}>
          <img ref={el => this._rowWrapperRef = el} alt="Story" src={learnMoreButton} style={{ width: '23vw' }} />
        </div>
      </div>
    )
  }

  getBackgroundImage = () => {
    const defaultImg = { path:'/img/miami/general/', file_name:'default_single_screen.jpg' }
    
    if (this.props.screensNumber === 2) {
      defaultImg.file_name = 'default_double_screen.jpg';
    }
    return dp(this.props.screen, _.get(this.props.module, 'contents.images[2]', null), defaultImg);
  }

  getIconImage = () => {
    return dp(this.props.screen, _.get(this.props.module, 'contents.images[1]', null), null);
  }

  getSubscribeModule = () => {
    const rootFolderId = _.get(this.props.content, 'settings.selected_root_folder', null);
    const menu = this.props.content.story_categories.find(folder => {
      const type = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
      return folder.parent_category === Number(rootFolderId) && type === "menu";
    });
    const rootFolder = this.props.content.story_categories.find(folder => folder.id === Number(rootFolderId));
    this._arrowIcon = dp(this.props.screen, _.get(menu, 'contents.images[0]', null), null);
    this._colorPallette = _.get(rootFolder, 'contents.custom_fields.color_pallette.val.value', 'golisano');
    const subscribeModule = this.props.content.story_categories.find(folder => {
      const type = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
      return folder.parent_category === Number(menu.id) && type === "be_the_change";
    });
    this._subscribeModule = subscribeModule;
  }

  renderCategories = () => {
    if (isNull(this._donorCategories)) {
      let categoryWrapStyle = {
        boxSizing: 'border-box',
        width: this.props.screen.screenWidth * 0.78838174273858921162,
        background: "white",
        // height: this.props.screen.r9_16.height * .5,
        paddingBottom: this.props.screen.screenHeight * 0.01875,
        paddingTop: this.props.screen.screenHeight * 0.02893518518518518519,
        borderRadius: 10,
        paddingLeft: this.props.screen.screenWidth * 0.074074074,
        paddingRight: this.props.screen.screenWidth * 0.074074074,
        marginBottom: this.props.screen.screenHeight * 0.03125
      }
      console.log(this._donorGroups[this.state.donorGroup])
      const descriptionRichText = new QuillDeltaToHtmlConverter(_.get(this._donorGroups[this.state.donorGroup], 'contents.custom_fields.description.val.ops', _.get(this._donorGroups[this.state.donorGroup], 'contents.custom_fields.description.default.ops', null)), {}).convert();

      this._donorCategories = (
        this._donorGroups[this.state.donorGroup].children.map(function (row, i) {
          const donors = getDonorsFromFolder(this.props.donors, this.props.content.folder_modules, row.id);
          const orderedDonors = _.orderBy(donors, ['sorting_name', 'asc']);
          let donorFullPageWidth = this.props.screen.screenWidth * 0.78838174273858921162 - (this.props.screen.screenWidth * 0.074074074 * 2);
          let beTheChange = this.beTheChange({ width: donorFullPageWidth });
          const hideTitle = _.get(row, 'contents.custom_fields.hide_title.val', false);

          const donorList = (
            <div key={i} style={{ display:"flex", alignItems:"center", justifyContent: "center" }}>
              <div style={{ ...categoryWrapStyle, }} className='opensans-regular'>
                { i === 0 ? <div style={{ lineHeight: "1.5625vh", paddingRight: this.props.screen.screenHeight * .01562, paddingLeft: this.props.screen.screenHeight * .01562 }} dangerouslySetInnerHTML={{ __html: descriptionRichText }}/> : null }
                {
                  hideTitle !== true ?
                  <div>
                    <h1 style={{ paddingRight: this.props.screen.screenHeight * .01562, paddingLeft: this.props.screen.screenHeight * .01562, fontSize: this.props.screen.screenHeight * 0.021875 }}>{row.name}</h1>
                  </div>
                  : null
                }
                <div>
                  <DonorFullPage
                    height={this.props.screen.screenHeight * 0.115}
                    width={donorFullPageWidth}
                    columns={this._columns}
                    rows={this._rows}
                    fontClass={this._fontclass}
                    donorData={orderedDonors}
                    screen={this.props.screen}
                    sort="column"
                    overrideFontSize={0}
                    overridePadding={this.props.screen.screenHeight * .01562}
                    overrideMarginRight={0}
                    custom1x2={'<span />'}>
                  </DonorFullPage>
                </div>
              </div>
            </div>
          )

          if (i === 1) {
            return (
              <div key={i}>
                {beTheChange}
                {donorList}
              </div>
            )
          }

          return donorList;
        }, this)
      )
    }
  }

  switchDonorGroup(groupRef) {
    this.setState({
      donorGroup: groupRef
    })
    this.iScroller.withIScroll((iScroll) => {
      iScroll.scrollTo(0, 0);
    })
    this._donorCategories = null;
  }

  redirect = () => {
    if (this._subscribeModule !== null && this._subscribeModule !== undefined) {
      this.props.navRoute('/miami/subscribe', this._subscribeModule);
    }
  }

  renderGroupInputs() {
    let optionsClass = "recognitionOptions";
    if (this._colorPallette === "adaptive") {
      optionsClass = "recognitionOptionsPrimary";
    }

    let recognitionOptionsLabel = {
      width: this.props.screen.screenWidth * 0.222222222,
      fontSize: this.props.screen.screenWidth * 0.016666667,
      paddingTop: this.props.screen.screenHeight * 0.0078125,
      paddingBottom: this.props.screen.screenHeight * 0.0078125,
      paddingLeft: this.props.screen.screenWidth * 0.010416667,
      paddingRight: this.props.screen.screenWidth * 0.010416667
    }

    switch (this._donorGroups.length) {
      case 2:
        return (
          <div className={optionsClass} style={{ left: this.state.recognitionOffsetX }} ref={(recognitionOptionsRef) => this._recognitionOptionsRef = recognitionOptionsRef}>
            <input id="switch_left" name="donorOptions" type="radio" value="cumulative_donors" defaultChecked></input>
            <label onMouseDown={() => this.switchDonorGroup(0)} htmlFor="switch_left" style={{ ...recognitionOptionsLabel }}>{this._donorGroups[0].name}</label>
            <input id="switch_right" name="donorOptions" type="radio" value="campaign_donors"></input>
            <label onMouseDown={() => this.switchDonorGroup(1)} htmlFor="switch_right" style={{ ...recognitionOptionsLabel }}>{this._donorGroups[1].name}</label>
          </div>
        )
      case 3:
        return (
          <div className={optionsClass} style={{ left: this.state.recognitionOffsetX }} ref={(recognitionOptionsRef) => this._recognitionOptionsRef = recognitionOptionsRef}>
            <input id="switch_left" name="donorOptions" type="radio" value="cumulative_donors" defaultChecked></input>
            <label onMouseDown={() => this.switchDonorGroup(0)} htmlFor="switch_left" style={{ ...recognitionOptionsLabel }}>{this._donorGroups[0].name}</label>
            <input id="switch_middle" name="donorOptions" type="radio" value="middle_donors"></input>
            <label onMouseDown={() => this.switchDonorGroup(1)} htmlFor="switch_middle" style={{ ...recognitionOptionsLabel }}>{this._donorGroups[1].name}</label>
            <input id="switch_right" name="donorOptions" type="radio" value="campaign_donors"></input>
            <label onMouseDown={() => this.switchDonorGroup(2)} htmlFor="switch_right" style={{ ...recognitionOptionsLabel }}>{this._donorGroups[2].name}</label>
          </div>
        )
      case 4:
        return (
          <div className={optionsClass} style={{ left: this.state.recognitionOffsetX }} ref={(recognitionOptionsRef) => this._recognitionOptionsRef = recognitionOptionsRef}>
            <input id="switch_left" name="donorOptions" type="radio" value="cumulative_donors" defaultChecked></input>
            <label onMouseDown={() => this.switchDonorGroup(0)} htmlFor="switch_left" style={{ ...recognitionOptionsLabel }}>{this._donorGroups[0].name}</label>
            <input id="switch_middle" name="donorOptions" type="radio" value="middle_donors"></input>
            <label onMouseDown={() => this.switchDonorGroup(1)} htmlFor="switch_middle" style={{ ...recognitionOptionsLabel }}>{this._donorGroups[1].name}</label>
            <input id="switch_middle1" name="donorOptions" type="radio" value="middle_donors"></input>
            <label onMouseDown={() => this.switchDonorGroup(2)} htmlFor="switch_middle1" style={{ ...recognitionOptionsLabel }}>{this._donorGroups[2].name}</label>
            <input id="switch_right" name="donorOptions" type="radio" value="campaign_donors"></input>
            <label onMouseDown={() => this.switchDonorGroup(3)} htmlFor="switch_right" style={{ ...recognitionOptionsLabel }}>{this._donorGroups[3].name}</label>
          </div>
        )
      default:
        break;
    }


  }

  render() {
    // return (<div/>)
    const background = this.getBackgroundImage();
    const iconImage = this.getIconImage();

    if (isNull(this._donorCategories)) {
      this.renderCategories();
    }
    const unit = this.props.screen.r9_16.p10;

    return (
      <div>
        <div style={{ position: 'absolute', width: this.props.screen.screenWidth, height: this.props.screen.r9_16.height, backgroundSize: "contain", backgroundImage: "url("+background+")" }} >
          <div style={{ display: "block", marginLeft: "auto", textAlign: "center", marginRight: "auto", width: '100%' }}>
            <div style={{ height: "5vw" }} />
            <img alt="Donor Recognition" src={iconImage} style={{ width: '24vw' }} />
          </div>

          <div style={{ fontFamily: 'opensans-extrabold', textAlign: "center", fontSize: '6.3vw' }}>
            {this.props.module.name.toUpperCase()}
          </div>
          <div style={{ fontFamily: 'opensans-regular', fontSize: '1.6851vh', textAlign: "center", paddingRight:"1vh", paddingLeft:"1vh" }}>
            {this.props.module.description}
          </div>
          <div className="topgradblackP25" style={{ position:"absolute", width: '100%', height: unit * .25, top:"26.8518vh" }} />

          <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "3.25vh" }}>
            {this.renderGroupInputs()}
          </div>

          <div style={{ height: "4.62962962962962962963vh" }} />
          <div ref={el => this._wrapperDiv = el} style={{ display: 'block', color: 'black', width: '85%', height: '73%', marginLeft: "auto", marginRight: "auto", touchAction:"none" }}>
            <ReactIScroll ref={el => this.iScroller = el} iScroll={iScroll}
              onScrollStart={this.handleScrollStart}
              options={{
                mouseWheel: true,
                scrollbars: false,
                scrollX: false,
                scrollY: true,
                probeType: 2,
                bounce: false,
                momentum: true,
                deceleration: 0.005,
                useTransition: true,
                disableTouch: false,
                disablePointer: false,
                disableMouse: false,
                tap: true
              }}
              onRefresh={this.initializeIScroll}
            >
              <CSSTransitionGroup
                component='div'
                transitionName='example'
                transitionEnterTimeout={0}
                transitionLeaveTimeout={0}>
                <div ref={el => this._innerDivRef = el} key={this.state.donorGroup}>
                  <div style={{ height:"2.5vh" }}></div>
                  {this._donorCategories}
                  <ScrollSpacer unit={unit} />
                </div>
              </CSSTransitionGroup>
            </ReactIScroll>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {

  return {
    content: state.content,
    donors: state.donors,
  };
};

export default connect(mapStateToProps, null)(MiamiRecognitionList);



// WEBPACK FOOTER //
// ./src/Components/Theme/Miami/MiamiRecognitionList.js